/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';

export type CourierReviewStatus = 'pending' | 'approved' | 'rejected';
export type CourierReviewSource = 'customer' | 'admin';

/**
 * A customer review of a courier. Customers submit (status pending); admins
 * moderate. Only approved reviews are exposed publicly via CourierReviewPublic.
 */
export interface CourierReview {
    id?: number;
    courierId?: number;
    customerId?: number;
    customerName: string;
    customerEmail?: string;
    packageId?: number;
    rating: number;
    title?: string;
    body: string;
    status?: CourierReviewStatus;
    source?: CourierReviewSource;
    isFeatured?: boolean;
    reviewNotes?: string;
    reviewedBy?: number;
    reviewedAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    // Relation includes
    customer?: any;
    package?: any;
    reviewer?: any;
}

export function instanceOfCourierReview(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customerName" in value;
    isInstance = isInstance && "rating" in value;
    isInstance = isInstance && "body" in value;
    return isInstance;
}

function toDate(v: any): Date | undefined {
    return v == null ? undefined : new Date(v);
}

export function CourierReviewFromJSON(json: any): CourierReview {
    return CourierReviewFromJSONTyped(json, false);
}

export function CourierReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierReview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'courierId': !exists(json, 'courierId') ? undefined : json['courierId'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'customerName': json['customerName'],
        'customerEmail': !exists(json, 'customerEmail') ? undefined : json['customerEmail'],
        'packageId': !exists(json, 'packageId') ? undefined : json['packageId'],
        'rating': json['rating'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': json['body'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'isFeatured': !exists(json, 'isFeatured') ? undefined : json['isFeatured'],
        'reviewNotes': !exists(json, 'reviewNotes') ? undefined : json['reviewNotes'],
        'reviewedBy': !exists(json, 'reviewedBy') ? undefined : json['reviewedBy'],
        'reviewedAt': !exists(json, 'reviewedAt') ? undefined : toDate(json['reviewedAt']),
        'createdAt': !exists(json, 'createdAt') ? undefined : toDate(json['createdAt']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : toDate(json['updatedAt']),
        'customer': !exists(json, 'customer') ? undefined : json['customer'],
        'package': !exists(json, 'package') ? undefined : json['package'],
        'reviewer': !exists(json, 'reviewer') ? undefined : json['reviewer'],
    };
}

export function CourierReviewToJSON(value?: Partial<CourierReview> | null): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'id': value.id,
        'courierId': value.courierId,
        'customerId': value.customerId,
        'customerName': value.customerName,
        'customerEmail': value.customerEmail,
        'packageId': value.packageId,
        'rating': value.rating,
        'title': value.title,
        'body': value.body,
        'status': value.status,
        'source': value.source,
        'isFeatured': value.isFeatured,
        'reviewNotes': value.reviewNotes,
        'reviewedBy': value.reviewedBy,
        'reviewedAt': value.reviewedAt === undefined ? undefined : (value.reviewedAt === null ? null : value.reviewedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
    };
}
